import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { closeStatusBar } from 'actions/statusBar';

import Button from 'components/ui-components/button';

import './styles.less';

const STATUS_BAR_TRANSITION_ENTER_TIMEOUT = 400;

const STATUS_BAR_TRANSITION_LEAVE_TIMEOUT = 300;

function createMarkup(message) {
  return { __html: message };
}

const StatusBar = class extends Component {
  constructor() {
    super();

    this.closeStatusBar = this.closeStatusBar.bind(this);
    this.performAction = this.performAction.bind(this);
  }

  render() {
    const { actionButtonValue, message, showing, title } = this.props;

    let actionButton = null;
    let statusBar = null;

    if (showing) {
      if (actionButtonValue && actionButtonValue.length > 0) {
        actionButton = (
          <Button
            buttonType="b2"
            buttonClass="action-button"
            value={actionButtonValue}
            onClicked={this.performAction}
          />
        );
      }

      statusBar = (
        <div className="status-bar">
          <div className="inner-container">
            <div className="message">
              <h4 className="title">{title}</h4>
              <p
                className="content"
                dangerouslySetInnerHTML={createMarkup(message)}
              />
            </div>
            <div className="buttons-area">
              {actionButton}
              <div className="close-button" onClick={this.closeStatusBar} />
            </div>
          </div>
        </div>
      );
    }

    return (
      <CSSTransitionGroup
        transitionName="status-bar"
        transitionEnterTimeout={STATUS_BAR_TRANSITION_ENTER_TIMEOUT}
        transitionLeaveTimeout={STATUS_BAR_TRANSITION_LEAVE_TIMEOUT}
      >
        {statusBar}
      </CSSTransitionGroup>
    );
  }

  closeStatusBar() {
    const { onClose } = this.props;

    if (onClose) {
      onClose();
    }

    this.props.closeStatusBar();
  }

  performAction() {
    const { onAction } = this.props;

    if (onAction) {
      onAction();
    }
  }
};

const mapStateToProps = state => {
  const {
    action_button_value: actionButtonValue,
    message,
    showing,
    title,
  } = state.status_bar;

  return { actionButtonValue, message, showing, title };
};

const mapDispatchToProps = dispatch => {
  return { closeStatusBar: () => dispatch(closeStatusBar()) };
};

export default connect(mapStateToProps, mapDispatchToProps)(StatusBar);
